<template>
  <div data-component-group="contract-form" data-component="billing">
    <slot name="beforeForm" />

    <v-autocomplete
      v-model="billingAccount"
      :items="billingAccounts"
      :loading="isLoadingAccounts"
      prepend-inner-icon="public"
      label="Billing account"
      item-title="legal_business_name"
      item-value="id"
      return-object
      required
      :readonly="isDisabled"
      v-model:search="billingAccountSearch"
      :error-messages="billingAccountErrors"
    />
    <div v-if="!isDisabled" class="component-actions">
      <v-btn color="secondary" @click="onUpdateBilling">
        <v-icon>edit</v-icon>
        {{ triggerLabel }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { v1 as uuidv1 } from 'uuid';
  import { useVuelidate } from '@vuelidate/core'
  import { required } from '@vuelidate/validators';
  import { isObj, isStr, debounce } from '../../../utils';

  const debouncer = debounce({
    id: uuidv1(),
    timeout: 500
  });

  export default {
    setup () {
    return {
      v$: useVuelidate()
    }
  },
    validations() {
      return {
        billingAccount: {
          required,
        },
      };
    },
    props: {
      contract: {
        type: Object,
        default: undefined,
      },
      triggerLabel: {
        type: String,
        default: 'Update',
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        billingAccount: null,
        billingAccountSearch: '',
        billingAccounts: [],
        isLoadingAccounts: false,
        isRefreshingBillingAccounts: false,
      };
    },
    computed: {
      billingAccountErrors() {
        return this.v$.billingAccount.$errors.map(error => {
          if (error.$validator === 'required') {
            return 'Billing account is required';
          }
          return error.$message;
        });
      },
    },
    watch: {
      contract: {
        handler(nextContract) {
          if (isObj(nextContract)) {
            this.extractContractData(nextContract);
          }
        },
        deep: true,
        immediate: true,
      },
      billingAccountSearch(nextSearch) {
        if (isStr(nextSearch)) {
          if (this.isRefreshingBillingAccounts) {
            this.isRefreshingBillingAccounts = false;
            return false;
          }

          debouncer(() => this.getAccounts(nextSearch));
        }
      },
    },
    methods: {
      onUpdateBilling() {
        const { billingAccount, onSubmit } = this;
        onSubmit(billingAccount);
      },
      extractContractData({ account }) {
        this.billingAccount = account;
        this.billingAccounts = account ? [account] : [];
      },
      getAccounts(search = '') {
        const query = {
          per_page: -1,
          search,
          business: this.contract.business_id,
        };

        this.isLoadingAccounts = true;
        return this.$store
          .dispatch('billing/getItems', query)
          .then(({ items }) => {
            this.billingAccounts = items;
            return items;
          })
          .finally(() => {
            this.isLoadingAccounts = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='contract-form'][data-component='billing'] {
  padding: $spacing-xl;
  background-color: map.get($colors, shades, 'white');
  border-top: 1px solid map.get($colors, grey, lighten-2);

  > .component-actions {
    padding: 12px 0 0 0;
    text-align: right;

    .v-btn {
      margin: 0;

      .v-icon {
        margin: 0 6px 0 0;
      }
    }
  }
}
</style>
